import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Remove destructuring, use default import
import toast from "react-hot-toast";
import Login from "./Admin/Login";
import Home from "./Admin/Home";
import Users from "./Admin/Users";
import Notfound from "./Admin/Layouts/Notfound";
import Basecoins from "./Admin/Basecoins";
import TokenTrans from "./Admin/TokenTrans";
import StakeTrans from "./Admin/StakeTrans";
import SwapTrans from "./Admin/SwapTrans";
import Wallet from "./Admin/Wallet";
import Settings from "./Admin/Settings";
import Support from "./Admin/Support";
import ChangePassword from "./Admin/ChangePassword";
import PushNotify from "./Admin/PushNotify";
import AddBaseCoin from "./Admin/AddBaseCoin";
import CoinTrans from "./Admin/CoinTrans";

import Landing from "./Components/Pages/Home/Home";
import PrivacyPolicy from "./Components/Pages/PrivacyPolicy";
import TermsCondition from "./Components/Pages/TermsCondition";

const App = () => {
  const isTokenExpired = () => {
    const token = sessionStorage.getItem("__token");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const isExpired = decodedToken.exp * 1000 < Date.now();
        if (isExpired) {
          sessionStorage.removeItem("__token");
        }
        return isExpired;
      } catch (error) {
        console.error("Invalid token", error);
        sessionStorage.removeItem("__token");
        return true;
      }
    }
    return true;
  };

  const isAuthenticated = () => {
    if (!sessionStorage.getItem("__token") || isTokenExpired()) {
      return false;
    }
    return true;
  };

  return (
    <>
      <Routes>
        {/*Pages*/}
        <Route path="/" element={<Landing />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />



        {/*Admin*/}
        <Route path="/Admin/Login" element={<Login />} />
        <Route
          path="/Admin/dashboard"
          element={
            isAuthenticated() ? <Home /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/UserList"
          element={
            isAuthenticated() ? <Users /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/Basecoins"
          element={
            isAuthenticated() ? <Basecoins /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/SwapTrans"
          element={
            isAuthenticated() ? <SwapTrans /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/StakeTrans"
          element={
            isAuthenticated() ? <StakeTrans /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/TokenTrans"
          element={
            isAuthenticated() ? <TokenTrans /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/MyWallet"
          element={
            isAuthenticated() ? <Wallet /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/Settings"
          element={
            isAuthenticated() ? <Settings /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/tickets"
          element={
            isAuthenticated() ? <Support /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/changePassword"
          element={
            isAuthenticated() ? <ChangePassword /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/pushNotify"
          element={
            isAuthenticated() ? <PushNotify /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/AddBasecoin"
          element={
            isAuthenticated() ? <AddBaseCoin /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route
          path="/Admin/CoinTrans"
          element={
            isAuthenticated() ? <CoinTrans /> : <Navigate to="/Admin/Login" />
          }
        />
        <Route path="*" element={<Notfound />} />
      </Routes>
    </>
  );
};

export default App;
